import { createReducer } from '../../../utils';
import { combineReducers } from 'redux';
import constant from './constant';


const statisticListHandlers = {
    [constant.statisticList](state, action) {
        return action.payload;
    }
};
const phoneConnListHandlers = {
    [constant.phoneConnList](state, action) {
        return action.payload;
    }
};
const nolmalXdataHandlers = {
    [constant.nolmalXdata](state, action) {
        return action.payload;
    }
};

const tencentXYdataHandlers = {
    [constant.tencentXYdata](state, action) {
        return action.payload;
    }
};

const agentsHandlers = {
    [constant.agents](state, action) {
        return action.payload;
    }
};
const areasHandlers = {
    [constant.areas](state, action) {
        return action.payload;
    }
};

const loadingHandlers = {
    [constant.loading](state, action) {
        return { ...state, loading: action.payload };
    },
}

const searchHandlers = {
    [constant.search](state, action) {
        return { ...state, ...action.payload }
    }
};

export const loading = createReducer({ loading: false }, loadingHandlers);
export const statisticList = createReducer([], statisticListHandlers);
export const phoneConnList = createReducer([], phoneConnListHandlers);
export const nolmalXdata = createReducer([], nolmalXdataHandlers);
export const tencentXYdata = createReducer([], tencentXYdataHandlers);

export const search = createReducer({}, searchHandlers);
export const agents = createReducer([], agentsHandlers);
export const areas = createReducer([], areasHandlers);

export const agentConnentData = combineReducers({
    loading,
    statisticList,
    phoneConnList,
    nolmalXdata,
    tencentXYdata,
    search,
    agents,
    areas,
})



// {
//     orders: [],
//     search :{
//     }
//
// }




// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agentConnentData/reducers.js